function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.3328118mm",
    height: "5.9226561mm",
    viewBox: "0 0 4.3328118 5.9226561",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.48326,-96.620314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 69.61451,101.84141 q 0.65625,0 1.019531,-0.63672 0.363281,-0.64063 0.363281,-1.804688 0,-1.019532 -0.339844,-1.554688 -0.335937,-0.539062 -0.980468,-0.539062 -0.652344,0 -1.007813,0.59375 -0.351562,0.59375 -0.351562,1.703125 0,1.074223 0.335937,1.656253 0.339844,0.58203 0.960938,0.58203 z m 2.101562,-2.488283 q 0,1.382813 -0.597656,2.238283 -0.59375,0.85156 -1.542969,0.85156 -0.902344,0 -1.449219,-0.73828 -0.542968,-0.74219 -0.542968,-1.976563 0,-1.402344 0.578125,-2.203125 0.578125,-0.804688 1.582031,-0.804688 0.945312,0 1.457031,0.6875 0.515625,0.6875 0.515625,1.945313 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit0);
export default __webpack_public_path__ + "static/media/digit-0.d1ebc3621e155251e665e7efe4ca2a02.svg";
export { ForwardRef as ReactComponent };